import type { ReactNode } from 'react';

interface PageContainerProps {
    children: ReactNode;
    variant?: 'normal' | 'compact' | 'full';
    padding?: 'none' | 'default';
    className?: string;
}

export const PageContainer = ({
                                  children,
                                  variant = 'normal',
                                  padding = 'default',
                                  className = ''
                              }: PageContainerProps) => {
    const variantClasses = {
        normal: 'max-w-[90rem]',
        compact: 'max-w-5xl',
        full: 'max-w-none'
    };

    const paddingClasses = {
        none: '',
        default: 'px-8 lg:px-10 py-6'
    };

    return (
        <div className={ `w-full mx-auto ${ variantClasses[variant] } ${ paddingClasses[padding] } ${ className }` }>
            { children }
        </div>
    );
};
